import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Axios from 'axios';
import { Container, Typography, CircularProgress, Paper, Alert, Box, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import config, { environment } from '../../config';

function MembershipAction() {
    const { t, i18n } = useTranslation();
    const { action, userId, token } = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [status, setStatus] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        const performAction = async () => {
            setLoading(true);
            try {
                let endpoint;
                if (action === 'approve') {
                    endpoint = config[environment].approveMembershipEndpoint(userId, token);
                } else if (action === 'reject') {
                    endpoint = config[environment].rejectMembershipEndpoint(userId, token);
                } else {
                    throw new Error('Invalid action');
                }

                const response = await Axios.post(endpoint);
                setStatus(response.data.detail || t('Profile.ActionSuccess', 'Művelet sikeresen végrehajtva.'));
            } catch (err) {
                console.error('Membership action error:', err);
                setError(err.response?.data?.detail || t('Profile.ActionFailed', 'A művelet nem sikerült. A link érvénytelen lehet vagy már felhasználták.'));
            } finally {
                setLoading(false);
            }
        };

        if (userId && token && (action === 'approve' || action === 'reject')) {
            performAction();
        } else {
            setError(t('Profile.InvalidLink', 'Érvénytelen link.'));
            setLoading(false);
        }
    }, [action, userId, token, t]);

    return (
        <Container maxWidth="sm" sx={{ py: 8 }}>
            <Paper elevation={3} sx={{ p: 4, textAlign: 'center', borderRadius: 4 }}>
                <Typography variant="h5" gutterBottom color="primary">
                    {action === 'approve' ? t('Profile.ApproveTitle', 'Tagság Jóváhagyása') : t('Profile.RejectTitle', 'Tagság Elutasítása')}
                </Typography>
                
                {loading ? (
                    <Box sx={{ py: 4 }}>
                        <CircularProgress />
                        <Typography sx={{ mt: 2 }}>{t('Profile.Processing', 'Feldolgozás...')}</Typography>
                    </Box>
                ) : (
                    <Box sx={{ mt: 2 }}>
                        {error ? (
                            <Alert severity="error" sx={{ mb: 3 }}>{error}</Alert>
                        ) : (
                            <Alert severity="success" sx={{ mb: 3 }}>{status}</Alert>
                        )}
                        <Button variant="contained" onClick={() => navigate(`/${i18n.language}/`)}>
                            {t('Header.Home', 'Kezdőlap')}
                        </Button>
                    </Box>
                )}
            </Paper>
        </Container>
    );
}

export default MembershipAction;
